module.exports = __webpack_public_path__ + "img/ic_full_screen.09539817.svg";